/*
 * <compare-slider> — before/after comparison slider
 * Markup: snippets/compare-slider.liquid  |  Styles: assets/compare-slider.css
 *
 * - Pointer events (mouse, touch, pen) on the host set --compare-pos.
 * - The visually hidden range input provides keyboard control (arrow keys).
 * - Safe to include more than once on a page (define guard), and safe to
 *   re-render in the theme editor (elements auto-upgrade).
 */
if (!customElements.get('compare-slider')) {
  class CompareSlider extends HTMLElement {
    constructor() {
      super();
      this.dragging = false;
      this.onInput = this.onInput.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
    }

    connectedCallback() {
      this.range = this.querySelector('.compare-slider__range');
      if (this.range) this.range.addEventListener('input', this.onInput);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointermove', this.onPointerMove);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerUp);
      this.addEventListener('dragstart', this.onDragStart);
      this.setPosition(this.range ? this.range.value : 50);
    }

    disconnectedCallback() {
      if (this.range) this.range.removeEventListener('input', this.onInput);
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointermove', this.onPointerMove);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerUp);
      this.removeEventListener('dragstart', this.onDragStart);
    }

    setPosition(value) {
      const v = Math.min(100, Math.max(0, parseFloat(value) || 0));
      this.style.setProperty('--compare-pos', `${v}%`);
      if (this.range && parseFloat(this.range.value) !== v) {
        this.range.value = v;
      }
    }

    positionFromEvent(e) {
      const rect = this.getBoundingClientRect();
      if (!rect.width) return 50;
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    onInput(e) {
      this.setPosition(e.target.value);
    }

    onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      this.dragging = true;
      this.classList.add('is-dragging');
      try { this.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      this.setPosition(this.positionFromEvent(e));
      e.preventDefault();
    }

    onPointerMove(e) {
      if (!this.dragging) return;
      this.setPosition(this.positionFromEvent(e));
    }

    onPointerUp(e) {
      if (!this.dragging) return;
      this.dragging = false;
      this.classList.remove('is-dragging');
      try { this.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
    }

    onDragStart(e) {
      e.preventDefault();
    }
  }

  customElements.define('compare-slider', CompareSlider);
}